export default __webpack_public_path__ + "static/media/2024OctShajeedCV.9e8e10a2.pdf";